import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'

const InteractorContentBlogDelete = () => {
  const { t } = useTranslation()
  const blogDelete = useCallback(
    (body, loading) => {
      const { uid, updated_by, blog_title } = body
      const payload = {
        uid,
        updated_by,
      }
      confirmationAlert({
        message: `${t('message.confirm_delete')} ${blog_title} ?`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/content-blog/delete', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_deleted'),
                timer: 1500,
                redirect: '/content/blog/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { blogDelete }
}

export default InteractorContentBlogDelete
